import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=06695f58&scoped=true&"
import script from "./ResultTable.vue?vue&type=script&lang=js&"
export * from "./ResultTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultTable.vue?vue&type=style&index=0&id=06695f58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06695f58",
  null
  
)

export default component.exports